import createBaseService from "@/api/base-service.ts";
import type { Calendar } from "@/features/dashboard/types/calendar.ts";

const calendarService = {
	...createBaseService<Calendar>("/calendars"),
};

export default calendarService;
